export const PLAYSTORE_URL="https://play.google.com/store/apps/details?id=com.swapapp.android"
export const SUPPORTED_LANGUAGES = { "en": "ENG", "hi": "हिंदी" }
export const APPSTORE_URL = "https://apps.apple.com/in/app/poolmoney-spendeasy/id6737477428";